export default __webpack_public_path__ + "static/media/search.d1153941.svg";